import React from 'react';
import ReactDOM from 'react-dom';
import Baza from './Baza';

ReactDOM.render(
  <React.StrictMode>
    <Baza />
  </React.StrictMode>,
  document.getElementById('root')
);